export const isLogin = function () {
    const token = localStorage.getItem('_uid');
    return !!token;
};


